import { useState } from 'react'
import { TAGS } from '../../../services/Tags'
import { useQuery } from '@tanstack/react-query'
import { tickets } from '../../../services/Tickets'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import Loader from '../../../components/Loader'
import TicketsCard from './components/TicketCard'
import Pagination from '../../../components/Pagination'
import { ITEMS_PER_PAGE } from '../../../utils/constants'

const Tickets = () => {
  const [page, setPage] = useState(0)
  const { data: ticketsData, isInitialLoading: isLoadingtickets } = useQuery(
    [TAGS.tickets, page],
    () => tickets({ page })
  )
  const { ticketList, countTicket } = ticketsData || []
  const notTickets = ticketList?.length === 0

  return (
    <DashboardWrapper dashboardWrapperClassName="mt-0 pt-0 mt-lg-5 pt-lg-5 w-100">
      <h1 className="text-on-bg-primary fw-bolder mb-4">Tickets</h1>
      {notTickets ? (
        <div className="text-on-bg-primary text-center d-flex flex-column justify-content-center align-items-center mt-5 pt-5">
          <h2 className="fw-bolder">No han llegado tickets todavía</h2>
          <span>
            Cuando las empresas completen el formulario, podrás ver la
            información solicitada en esta sección.
          </span>
        </div>
      ) : isLoadingtickets ? (
        <Loader />
      ) : (
        ticketList?.map((props) => <TicketsCard key={props?.id} {...props} />)
      )}
      <Pagination
        totalItems={countTicket}
        itemsPerPage={ITEMS_PER_PAGE}
        page={page}
        setPage={setPage}
      />
    </DashboardWrapper>
  )
}

export default Tickets

//No han llegado tickets todavía
